// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore/lite";
import { initializeAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDWK0lF1IlZCJ_aNwiRCP1K3XjVZ4nScXg",
  authDomain: "zakariahome-4bcdb.firebaseapp.com",
  projectId: "zakariahome-4bcdb",
  storageBucket: "zakariahome-4bcdb.firebasestorage.app",
  messagingSenderId: "742088009390",
  appId: "1:742088009390:web:ffccb61f54fb6608bdaf3f",
  measurementId: "G-ZLSDVSMLD0",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = initializeAuth(app);
export { db, app, auth };
